import { CALL_API, Schemas } from '../../common/middleware/api';

export const PARENTS_REQUEST = 'PARENTS_REQUEST';
export const PARENTS_SUCCESS = 'PARENTS_SUCCESS';
export const PARENTS_FAILURE = 'PARENTS_FAILURE';

export const PARENTS_UNPAGED_REQUEST = 'PARENTS_UNPAGED_REQUEST';
export const PARENTS_UNPAGED_SUCCESS = 'PARENTS_UNPAGED_SUCCESS';
export const PARENTS_UNPAGED_FAILURE = 'PARENTS_UNPAGED_FAILURE';

export const PARENT_FETCH_REQUEST = 'PARENT_GET_REQUEST';
export const PARENT_FETCH_SUCCESS = 'PARENT_GET_SUCCESS';
export const PARENT_FETCH_FAILURE = 'PARENT_GET_FAILURE';

export const PARENT_CREATE_REQUEST = 'PARENT_CREATE_REQUEST';
export const PARENT_CREATE_SUCCESS = 'PARENT_CREATE_SUCCESS';
export const PARENT_CREATE_FAILURE = 'PARENT_CREATE_FAILURE';

export const PARENT_UPDATE_REQUEST = 'PARENT_UPDATE_REQUEST';
export const PARENT_UPDATE_SUCCESS = 'PARENT_UPDATE_SUCCESS';
export const PARENT_UPDATE_FAILURE = 'PARENT_UPDATE_FAILURE';

export const PARENT_SEND_MESSAGE_REQUEST = 'PARENT_SEND_MESSAGE_REQUEST';
export const PARENT_SEND_MESSAGE_SUCCESS = 'PARENT_SEND_MESSAGE_SUCCESS';
export const PARENT_SEND_MESSAGE_FAILURE = 'PARENT_SEND_MESSAGE_FAILURE';

export const loadParents = ({ name, ...options }) => ({
	[CALL_API]: {
		types: [PARENTS_REQUEST, PARENTS_SUCCESS, PARENTS_FAILURE],
		endpoint: 'api/parents',
		request: { name, ...options },
		schema: Schemas.PARENT_ARRAY
	},
	searchTerm: name || ''
});

export const loadParentsWithPendingPayment = (options) => ({
	[CALL_API]: {
		types: [PARENTS_UNPAGED_REQUEST, PARENTS_UNPAGED_SUCCESS, PARENTS_UNPAGED_FAILURE],
		endpoint: 'api/parents/pendingPayment',
		request: options,
		schema: Schemas.PARENTS_WITH_PENDING_PAYMENT_ARRAY,
		replace: { replace: true }
	}
});

export const fetchParent = (id, onErrorEvent, onSuccessEvent) => ({
	[CALL_API]: {
		types: [PARENT_FETCH_REQUEST, PARENT_FETCH_SUCCESS, PARENT_FETCH_FAILURE],
		endpoint: `api/parents/${id}`,
		schema: Schemas.PARENT,
		onSuccessEvent,
		onErrorEvent
	},
	searchTerm: ''
});

export const createParent = (parent, history) => ({
	[CALL_API]: {
		types: [PARENT_CREATE_REQUEST, PARENT_CREATE_SUCCESS, PARENT_CREATE_FAILURE],
		endpoint: 'api/parents',
		method: 'POST',
		request: parent,
		schema: Schemas.PARENT,
		form: 'parent',
		transition: {
			history,
			successPath: (response) => {
				return `/parents/${response.result}`;
			}
		}
	}
});

export const updateParent = (id, parent) => ({
	[CALL_API]: {
		types: [PARENT_UPDATE_REQUEST, PARENT_UPDATE_SUCCESS, PARENT_UPDATE_FAILURE],
		endpoint: `api/parents/${id}`,
		method: 'PUT',
		request: parent,
		schema: Schemas.PARENT,
		form: 'parent'
	}
});


export const sendMessage = (options, onSuccessEvent) => ({
	[CALL_API]: {
		types: [PARENT_SEND_MESSAGE_REQUEST, PARENT_SEND_MESSAGE_SUCCESS, PARENT_SEND_MESSAGE_FAILURE],
		endpoint: 'api/parents/message',
		method: 'POST',
		request: options,
		onSuccessEvent,
		form:'sendMessage'
	}
});